import React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { useCommonContent } from '../../graphql/pimcore/modules/siteContent/hooks/useCommonContent';

interface SearchBarProps {
    inputValue: string;
    onInputChange: (value: string) => void;
}

const SearchBar = React.memo(({ inputValue, onInputChange }: SearchBarProps) => {
    const { contentTree: cmsCommonContent } = useCommonContent();
    const cmsContent = cmsCommonContent.ResourceLibrary;
    return (
        <TextField
            variant="outlined"
            placeholder={cmsContent.searchInputPlaceholder.content}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon />
                    </InputAdornment>
                ),
                sx: {
                    height: '50px',
                    borderRadius: '50px',
                },
            }}
            sx={{
                width: '100%',
                maxWidth: '700px',
                '& .MuiOutlinedInput-root': {
                    borderRadius: '50px',
                    '& fieldset': {
                        borderColor: '#B75332',
                    },
                    '&:hover fieldset': {
                        borderColor: '#B75332',
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: '#B75332',
                    },
                },
                '& .MuiInputBase-root': {
                    backgroundColor: '#ffffff',
                },
            }}
            value={inputValue}
            onChange={(e) => onInputChange(e.target.value)}
        />
    );
});

SearchBar.displayName = 'SearchBar';

export default SearchBar;
